import React from "react";
import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useCustomers from "./useCustomers";

const PurchaseForm = () => {
  const { drawerMenu } = useCustomers();
  return (
    <CommonLayout drawerMenu={drawerMenu} dashboard={true}>
      <Outlet />
    </CommonLayout>
  );
};

export default PurchaseForm;
